import { useEffect, useState } from 'react'
import './button-like.scss'
// icons
import { HeartIcon, HeartActiveIcon } from '../icons'

const ButtonLike = props => {
	const { classes, active, setFavorite, dataToSet, size = '2rem' } = props

	// actions
	const [clickState, setClickState] = useState('')

	const deletePulse = () => setTimeout(() => setClickState(''), 500)

	const handledPulse = () => {
		setClickState('pulse')
		deletePulse()
	}

	useEffect(() => {
		return clearTimeout(deletePulse)
	}, [clickState])

	return (
		<button
			style={{ width: size, height: size, fontSize: size }}
			className={`
        a-button-like 
        ${classes}
				${clickState}
      `}
			onClick={() => {
				handledPulse()
				setFavorite(dataToSet)
			}}
		>
			{active ? <HeartActiveIcon /> : <HeartIcon />}
		</button>
	)
}

export default ButtonLike
